export default __webpack_public_path__ + "static/media/bell.c95af452.svg";